// extracted by mini-css-extract-plugin
module.exports = {"component":"ConnectList_component__3wk9K","title":"ConnectList_title__1UTlc","button":"ConnectList_button__iY_2g","load":"ConnectList_load__2UWYA"};